(function () {
  'use strict';

  const PROPERTY_NAME = 'Leveransstatus';

  function findProductSection(element) {
    if (!element) return null;

    return (
      element.closest('.shopify-section') ||
      element.closest('[data-section-id]') ||
      element.closest('section') ||
      null
    );
  }

  function getCurrentMessage(inventory) {
    if (!inventory) return '';

    const textElement = inventory.querySelector(
      '.product-inventory__text'
    );

    if (textElement) {
      const text = textElement.textContent.trim();

      if (text) {
        return text;
      }
    }

    return (
      inventory.getAttribute('data-inventory-message') || ''
    ).trim();
  }

  function getFormsForInventory(inventory) {
    const section = findProductSection(inventory);

    if (!section) return [];

    return Array.from(
      section.querySelectorAll('form[action*="/cart/add"]')
    );
  }

  function updateForm(form, message) {
    if (!form) return;

    let input = form.querySelector(
      'input[name="properties[' + PROPERTY_NAME + ']"]'
    );

    if (!message) {
      if (input) {
        input.remove();
      }

      return;
    }

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + PROPERTY_NAME + ']';
      form.appendChild(input);
    }

    input.value = message;
  }

  function syncInventory(inventory) {
    if (!inventory) return;

    const message = getCurrentMessage(inventory);

    getFormsForInventory(inventory).forEach(function (form) {
      updateForm(form, message);
    });
  }

  function observeInventory(inventory) {
    if (
      !inventory ||
      inventory.dataset.deliveryStatusObserved === 'true'
    ) {
      return;
    }

    inventory.dataset.deliveryStatusObserved = 'true';

    /*
     * Sätt rätt värde direkt.
     */
    syncInventory(inventory);

    /*
     * Observera ändringar i själva lagerblocket.
     * När Savoy byter text för vald variant
     * synkroniseras Leveransstatus omedelbart.
     */
    const observer = new MutationObserver(function () {
      syncInventory(inventory);
    });

    observer.observe(inventory, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-inventory-message']
    });
  }

  function observeAllInventoryBlocks() {
    document
      .querySelectorAll('product-inventory')
      .forEach(function (inventory) {
        observeInventory(inventory);
      });
  }

  /*
   * Första sidladdningen.
   */
  function init() {
    observeAllInventoryBlocks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /*
   * Om Shopify/Savoy ersätter hela inventory-blocket
   * vid variantbyte hittar vi även det nya blocket.
   */
  const pageObserver = new MutationObserver(function (mutations) {
    let needsScan = false;

    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (
          node.nodeType === 1 &&
          (
            node.matches?.('product-inventory') ||
            node.querySelector?.('product-inventory')
          )
        ) {
          needsScan = true;
        }
      });
    });

    if (needsScan) {
      observeAllInventoryBlocks();
    }
  });

  pageObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  /*
   * Extra säkerhet precis före vanlig form-submit.
   */
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;

      if (
        !form ||
        !form.matches ||
        !form.matches('form[action*="/cart/add"]')
      ) {
        return;
      }

      const section = findProductSection(form);

      if (!section) return;

      const inventory =
        section.querySelector('product-inventory');

      if (inventory) {
        syncInventory(inventory);
      }
    },
    true
  );

  /*
   * Shopify Theme Editor.
   */
  document.addEventListener(
    'shopify:section:load',
    function () {
      observeAllInventoryBlocks();
    }
  );
})();